import { css } from '@emotion/react';

export default css({
    height: '100%',
    padding: '16px',
});
